module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="row">\n    <div class="col-xs-2 col btn-container">\n        <a class="open-button btn" target="_blank">Open</a>\n    </div>\n    <div class="col-xs-10 col">\n        <input\n            id="url-input"\n            class="url-box"\n            type="text"\n            value="' +
__e(url) +
'"\n            data-toggle     = "popover"\n            data-placement  = "bottom"\n            data-trigger    = "hover"\n            data-content    = "Press ' +
__e(button) +
'-C to copy."\n            onMouseOver="this.select();"\n            onMouseOut="this.select();"\n            onClick="this.select();"\n            readonly\n        />\n    </div>\n</div>\n<span class="help-block">' +
__e( helpText ) +
'</span>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/common/URLBox.tpl
// module id = 2877
// module chunks = 0